"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getClassNames = void 0;

var _react = require("@fluentui/react");

var _stylingConstants = require("../../styling/stylingConstants");

var _AppBar = require("../AppBar/AppBar.classNames");

var logoTopPadding = _stylingConstants.gridUnit; // Note: Logo is 280 by 60px for an aspect ratio of 4.6666
// Space is reserved for the bottom and top padding

var logoHeight = _AppBar.APP_BAR_PIXEL_HEIGHT - logoTopPadding * 2;
var logoWidth = 280 / 60 * logoHeight;
var getClassNames = (0, _react.memoizeFunction)(function (theme) {
  var semanticColors = theme.semanticColors;
  return {
    section: (0, _react.mergeStyles)({
      display: 'flex',
      flex: '0 0 auto'
    }),
    title: (0, _react.mergeStyles)({
      justifyContent: 'center'
    }),
    titleSmall: (0, _react.mergeStyles)({
      flex: '1 0 auto'
    }),
    tenantLogo: (0, _react.mergeStyles)({
      maxHeight: logoHeight,
      maxWidth: logoWidth,
      justifyContent: 'center',
      padding: logoTopPadding,
      paddingLeft: _stylingConstants.gridUnit * 2,
      paddingRight: _stylingConstants.gridUnit * 2
    }),
    inSearch: (0, _react.mergeStyles)({
      selectors: {
        '& .ms-AppBar': {
          background: semanticColors.headerBackgroundSearch
        },
        '& .ms-Button--appBar': {
          background: semanticColors.headerButtonsBackgroundSearch
        },
        '& .ms-Button--appBar:hover': {
          background: semanticColors.headerButtonsBackgroundSearchHover
        },
        '& .ms-AppBarTitle': {
          color: theme.palette.white
        },
        '& .ms-AppBarTitle a': {
          color: theme.palette.white
        },
        '& .ms-Dropdown .ms-Dropdown-title': {
          color: theme.palette.white + ' !important'
        },
        '& .ms-Dropdown-caretDown': {
          color: theme.palette.white + ' !important'
        }
      }
    }),
    extendedSearch: (0, _react.mergeStyles)({
      selectors: {
        '& .ms-SearchBox': {
          display: 'flex',
          borderRadius: '2px',
          margin: '0 32px',
          width: '375px'
        }
      }
    }),
    search: (0, _react.mergeStyles)({
      alignItems: 'center',
      selectors: {
        '& .ms-SearchBox': {
          display: 'flex',
          backgroundColor: semanticColors.headerSearchBoxBackground || 'rgba(255, 255, 255, 0.7)',
          borderRadius: '2px',
          margin: '0 32px',
          width: '375px'
        },
        '& .ms-SearchBox-iconContainer': {
          color: semanticColors.headerSearchPlaceholderText || theme.palette.black
        },
        '& .ms-SearchBox-field': {
          color: theme.palette.black
        },
        '& .ms-SearchBox-field::-webkit-input-placeholder': {
          color: semanticColors.headerSearchPlaceholderText || theme.palette.black
        }
      }
    }),
    modalSearch: (0, _react.mergeStyles)({
      selectors: {
        '& .ms-SearchBox': {
          margin: '0 16px 0 8px',
          width: '100%'
        }
      }
    })
  };
});
exports.getClassNames = getClassNames;